import React, { Component } from 'react';
//import PropTypes from 'prop-types';
//import { Redirect } from 'react-router'
//import { Link } from 'react-router-dom'
import Item from '../containers/Item'

class ItemQueueView extends Component {

  render() {

    return (
      <div>
        <p className="queue-title">Item Queue</p>

        <ul className="queue-list">
          { this.props.item_ids.map((item_id) => {
              return <Item key={item_id} something="y" item={this.props.items_by_id.get(item_id)} />
            })
          }
        </ul>
      </div>
    )

  }
}

// WelcomeView.propTypes = {
//   current_user_id: PropTypes.number
// };

export default ItemQueueView;



// WEBPACK FOOTER //
// ./src/snapit_app/components/ItemQueueView.js